import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { Grid, PageWrapper } from "components/Containers";
import PageTitle from "components/PageTitle";
import { InterviewEditModal, InterviewsList } from "components/VideoPresentation";
import Card from "components/Card";
import { PrimaryButton } from "components/Buttons";
import { GET_INTERVIEWS } from "graphql/queries";

/**
 * Video Presentation Settings
 */
const VideoPresentationSettings = () => {
  const intl = useIntl();
  const [showCreateForm, setShowCreateForm] = useState(false);

  return (
    <PageWrapper>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.VideoPresentation.Title" })}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle
            subtitle={<FormattedMessage id="Settings.Interviews.Title" />}
            actionBar={
              <PrimaryButton onClick={() => setShowCreateForm(true)}>
                <FormattedMessage id="Settings.Interviews.Create" />
              </PrimaryButton>
            }
          />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <Card>
            <InterviewsList />
          </Card>
        </Grid.col>
      </Grid>
      <InterviewEditModal
        show={showCreateForm}
        onClose={() => setShowCreateForm(false)}
        refetchQueries={[GET_INTERVIEWS]}
      />
    </PageWrapper>
  );
};

export default VideoPresentationSettings;
